import React from 'react';
import { motion } from 'framer-motion';
import { FingerprintIcon, ScanLineIcon, SearchIcon, SmartphoneIcon, ArrowRightIcon, DownloadIcon } from 'lucide-react';
export function Services() {
  const services = [{
    icon: FingerprintIcon,
    title: 'Ink/Card Fingerprinting',
    description: 'CJIS-CR will capture your fingerprints manually with ink and paper, then submit them for processing and analysis.'
  }, {
    icon: ScanLineIcon,
    title: 'LiveScan Fingerprinting',
    description: 'CJIS-CR will capture your fingerprints through a glass plate scanner and transmit them to a database for processing.'
  }, {
    icon: SearchIcon,
    title: 'Background Check',
    description: 'With your consent, CJIS-CR will collect and verify information from various sources, evaluate findings, and relay them to you.'
  }, {
    icon: SmartphoneIcon,
    title: 'Mobile Fingerprinting',
    description: 'CJIS-CR will capture your fingerprints electronically and submit them for processing and analysis.'
  }];
  return <section id="services" className="py-24 bg-white" aria-labelledby="services-heading" data-id="element-199">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-200">
        <div className="text-center mb-16" data-id="element-201">
          <h2 id="services-heading" className="text-3xl md:text-4xl font-bold text-[#1E1F55] mb-4" data-id="element-202">
            Services We Offer
          </h2>
          <div className="w-24 h-1 bg-[#4AA6CF] mx-auto rounded-full" aria-hidden="true" data-id="element-203"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16" data-id="element-204">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white border border-gray-100 rounded-2xl p-8 shadow-sm hover:shadow-lg transition-all flex flex-col h-full group" data-id="element-205">
              <div className="flex items-start gap-4 mb-4" data-id="element-206">
                <div className="p-3 bg-[#F0F4FF] rounded-lg text-[#4AA6CF] group-hover:bg-[#4AA6CF] group-hover:text-white transition-colors" data-id="element-207">
                  <service.icon className="h-8 w-8" aria-hidden="true" data-id="element-208" />
                </div>
                <h3 className="text-xl font-bold text-[#1E1F55] mt-1" data-id="element-209">
                  {service.title}
                </h3>
              </div>
              <p className="text-gray-600 leading-relaxed mb-8 flex-grow" data-id="element-210">
                {service.description}
              </p>
              <a href="#/booking" className="inline-flex items-center text-[#2B7A9E] font-semibold hover:text-[#1E1F55] transition-colors mt-auto" data-id="element-211">
                Book Appointment
                <ArrowRightIcon className="ml-2 h-4 w-4" aria-hidden="true" data-id="element-212" />
              </a>
            </motion.div>)}
        </div>

        <div className="flex justify-center" data-id="element-213">
          <motion.a href="#" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="inline-flex items-center justify-center gap-2 px-8 py-4 border-2 border-[#1E1F55] text-[#1E1F55] rounded-full font-bold hover:bg-[#1E1F55] hover:text-white transition-colors w-full sm:w-auto" aria-label="Download LiveScan Pre-Registration Form (PDF)" data-id="element-214">
            <DownloadIcon className="h-5 w-5" aria-hidden="true" data-id="element-215" />
            Download LiveScan Pre-Registration Form
          </motion.a>
        </div>
      </div>
    </section>;
}